import * as React from "react";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";

interface SheetProps {
	maxWidth?: number;
	paddingTop?: number;
	paddingLeft?: number;
	paddingRight?: number;
	paddingBottom?: number;
	contentClass?: string;
}

type Props = SheetProps & WithStyles<typeof styles>;

export class Sheet extends React.Component<Props, {}> {
	public static defaultProps: SheetProps = {
		maxWidth: null
	};

	render() {
		const {
			classes,
			maxWidth,
			paddingTop,
			paddingLeft,
			paddingRight,
			paddingBottom,
			contentClass
		} = this.props;

		let contentClassName = classes.sheetContent;

		if (contentClass) {
			contentClassName += " " + contentClass;
		}

		return (
			<div
				className={classes.sheet}
				style={{
					maxWidth: maxWidth,
					paddingTop: paddingTop,
					paddingLeft: paddingLeft,
					paddingRight: paddingRight,
					paddingBottom: paddingBottom
				}}
			>
				<div className={contentClassName}>
					{this.props.children}
				</div>
			</div>
		);
	}
}

const styles = (theme: Theme) =>
	createStyles({
		sheet: {
			position: "relative",
			padding: theme.spacing.unit * 3,
			background: "#EEEEEE",
			flexGrow: 1,
			height: "calc(100vh - 48px)",

			"@media (max-width: 959px)": {
				padding: 10
			}
		},
		sheetContent: {
			height: "100%",
			overflow: "auto",
			"-webkitOverflowScrolling": "touch"
		}
	});

export const ConnectedSheet = withStyles(styles)(Sheet);
